var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10MouseExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M758.662 563.953C758.307 560.224 761.239 557 764.984 557C767.925 557 770.481 559.019 771.162 561.88L772.978 569.507C774.01 573.84 770.724 578 766.27 578C762.715 578 759.743 575.297 759.406 571.758L758.662 563.953Z",
    fill: "#2B2D43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M758.662 562.953C758.307 559.224 761.239 556 764.984 556C767.925 556 770.481 558.019 771.162 560.88L772.978 568.507C774.01 572.84 770.724 577 766.27 577C762.715 577 759.743 574.297 759.406 570.758L758.662 562.953Z",
    fill: "#3E4054"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 763.829,
    y: 559.095,
    width: 2,
    height: 4,
    rx: 1,
    transform: "rotate(-5 763.829 559.095)",
    fill: "#2B2D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10MouseExternal);
export default __webpack_public_path__ + "static/media/10MouseExternal.15fe97fd602f2f2b1d33bff5a5e005bd.svg";
export { ForwardRef as ReactComponent };